import { adminHttpClient } from '../../../commons/adminHttpClient'
import { Wizard } from '../../../../domain/wizard/wizard'

const getPerksDesignBenefitWizard = async (planPeriod?: string): Promise<Wizard> => {
  return await adminHttpClient.get(`/AdminDashboard/perks/BenefitDetails/BenefitDesignWizard/${planPeriod}`)
}

export default getPerksDesignBenefitWizard
